module.exports = __webpack_public_path__ + "static/media/reset.d1f69450.png";